import React from 'react';
import { Modal, Tag, Empty } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { useTranslation } from 'react-i18next';
import { ItemBarcode, WLocation } from "@/types/inventoryV2";
import { getLocationCode } from '@/pages/Warehouse/utils';
import SText from '@/styles/SText';
import CommonTable from "@/components/CommonTable";

interface LocBarcode {
  count: number;
  location: WLocation;
  barcodes: Array<ItemBarcode | string>
}

interface PreviewLocationCodeProps {
  visible: boolean;
  onClose: () => void;
  locationBarcodes: Array<LocBarcode>;
  title?: string;
}

interface BarcodeRecord {
  locationCode: string;
  locationId: string;
  barcode: string;
  count: number;
}

const PreviewLocationCode: React.FC<PreviewLocationCodeProps> = ({
  visible,
  onClose,
  locationBarcodes,
  title
}) => {
  const { t } = useTranslation();

  // 将库位和条码数据展平为表格数据
  const getBarcodeData = (): BarcodeRecord[] => {
    const data: BarcodeRecord[] = [];

    locationBarcodes?.forEach(location => {
      const locationCode = getLocationCode(location.location);

      // 只有当有条码时才添加数据
      if (location.barcodes && location.barcodes.length > 0) {
        location.barcodes.forEach(barcodeItem => {
          data.push({
            locationCode,
            locationId: location.location?.id ?? '',
            barcode: typeof barcodeItem === 'string' ? barcodeItem : (barcodeItem?.barcode || ''),
            count: location.count
          });
        });
      }
    });

    return data;
  };

  const columns: ColumnsType<BarcodeRecord> = [
    {
      title: t('order.serialMumber'),
      key: 'index',
      width: 60,
      align: 'center',
      render: (_, __, index) => index + 1
    },
    {
      title: t('warehouse.locationCode'),
      dataIndex: 'locationCode',
      key: 'locationCode',
      width: 280,
      render: (text) => (
        <div>
          <Tag color="blue">{text}</Tag>
        </div>
      )
    },
    {
      title: t('warehouse.code'),
      dataIndex: 'barcode',
      key: 'barcode',
      render: (text) => <SText text={text} style={{ width: '100%' }} />
    },
  ];

  const barcodeData = getBarcodeData();

  return (
    <Modal
      title={title || t('warehouse.viewBarcode')}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={1000}
      destroyOnClose
    >
      {barcodeData.length > 0 ? (
        <CommonTable
          columns={columns}
          dataSource={barcodeData}
          rowKey={(record, index) => `${record.locationId}-${record.barcode}-${index}`}
          pagination={false}
          size="small"
          bordered
          scroll={{ y: 400 }}
          virtual
        />
      ) : (
        <Empty description={t('warehouse.noBarcodes')} />
      )}
    </Modal>
  );
};

export default PreviewLocationCode;